module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/5x10_small-f9d158b71a3d8afb97223c7a0a3ac72a.png";